const FromArrEditor = [{
		key: 'ProvinceID',
		modelvalue: undefined,
		title: "省份：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 130,
		height: 32,
		disabled: false,
		marginLeft: 0,
		marginTop: 8,
		displayVal: "inline-block",
		fontWeightVal: 400,
		options: [],
	}, {
		key: 'CityID',
		modelvalue: undefined,
		title: "城市：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 145,
		height: 32,
		disabled: false,
		marginLeft: 38,
		marginTop: 8,
		displayVal: "inline-block",
		fontWeightVal: 400,
		options: [],
	}, {
		key: 'DistrictID',
		modelvalue: undefined,
		title: "地区：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 152,
		height: 32,
		disabled: false,
		marginLeft: 31,
		marginTop: 8,
		displayVal: "inline-block",
		fontWeightVal: 400,
		options: [],
	}, {
		key: 'Name',
		title: "名称：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 120,
		height: 32,
		disabled: false,
		marginLeft: 0,
		marginTop: 14,
		displayVal: "inline-block",
		fontWeightVal: 400
	},
	{
		key: 'StartDate',
		title: "启效日期：",
		inputtype: "date",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		placeholder: "请输入",
		width: 125,
		height: 32,
		disabled: false,
		marginLeft: 28,
		marginTop: 22,
		displayVal: "inline-block",
		fontWeightVal: 400
	},
	{
		key: 'EndDate',
		title: "有效期至：",
		inputtype: "date",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		placeholder: "请输入",
		width: 125,
		height: 32,
		disabled: false,
		marginLeft: 30,
		marginTop: 22,
		displayVal: "inline-block",
		fontWeightVal: 400
	}
];
export default FromArrEditor;